import { combineReducers } from "redux";
import { filesReducer } from "./files.js";
import { pagesReducer } from "./pages.js";
import { notificationsReducer } from "./notifications.js";
import { showRoomsReducer } from "./revendeur.js";
import { modalReducer } from "./modal.js";
import { productsReducer } from "./products.js";
import { articlesReducer } from "./articles.js";
import { eventsReducer } from "./events.js";
import { usersReducer } from "./users.js";
import { contactsReducer } from "./contact.js";
import listsReducer from "./lists.js";

import statsReducer from "./stats.js";

const rootReducer = combineReducers({
  pagesReducer,
  notificationsReducer,
  filesReducer,
  showRoomsReducer,
  modalReducer,
  productsReducer,
  articlesReducer,
  eventsReducer,
  usersReducer,
  contactsReducer,
  listsReducer,
  statsReducer,
});
export default rootReducer;
